import React, { useRef } from "react";

import { Grid, Box } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Button, { Color } from "../../../../components/Form/Button";
import { StackFooter, TypographyButton } from "../../../../components/SignUp/styled";
import env from "../../../../util/env";
import { AppConfig, LINKS } from "../../../../constants";
import UpdatePasswordForm, { UpdatePasswordFormHandle } from "../../UpdatePassword/components/Form";
import useStyles from "./styles";

const confirmedCompany = require("Assets/img/confirmed-rafiki.svg");

interface Props {
  showCompletedPage: boolean;
  loading: boolean;
  handleSubmitPassword: (password: string) => void;
}

const SetPassword = ({ showCompletedPage, loading, handleSubmitPassword }: Props) => {
  const history = useHistory();

  const classes = useStyles();

  const { t: translate } = useTranslation();

  const updatePasswordFormRef = useRef<UpdatePasswordFormHandle>(null);

  const handleSubmit = (e: any) => {
    e.preventDefault();

    handleSubmitPassword(updatePasswordFormRef?.current?.password || "");
  };

  return (
    <div className={classes.mainDiv}>
      <Grid className={classes.container} container direction="row">
        <Grid item xs={12} sm={6}>
          <Box className={classes.leftBox}>
            <img
              src={AppConfig.appLogo}
              alt="session-logo"
              className={classnames("img-fluid", classes.image)}
            />
            <div className={classes.imageUpdatePasswordContainer}>
              <img
                src={confirmedCompany}
                className={classes.imageUpdatePassword}
                data-cy="updatePasswordImage"
              />
            </div>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            className={classes.rightBox}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {showCompletedPage ? (
              <Box className={classes.emailSentBoxContainer}>
                <Stack
                  className={classes.mainGrid}
                  justifyContent="center"
                  alignItems="center"
                  spacing={3}
                >
                  <h2 className={classes.title}>{translate("youreReadyToGo")}</h2>
                  <Button
                    fullWidth
                    customColor={Color.SECONDARY}
                    data-cy="goToLoginPageButton"
                    onClick={() => history.replace("/signin")}
                  >
                    {translate("goToLoginPage")}
                  </Button>
                </Stack>
              </Box>
            ) : (
              <UpdatePasswordForm
                ref={updatePasswordFormRef}
                handleSubmit={handleSubmit}
                isLoading={loading}
              />
            )}
          </Box>
        </Grid>
      </Grid>

      <StackFooter position="absolute" bottom={0} direction="row" spacing={2}>
        <Typography color="#465869" fontSize="12px" fontWeight={500} fontFamily="Manrope">
          {translate("shipeezi")}
        </Typography>
        <TypographyButton
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          data-cy="redirectContactForm"
          onClick={() => window.open("https://shipeezi.com/#contact-form", "_blank")}
        >
          {translate("contact")}
        </TypographyButton>
        <TypographyButton
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          data-cy="redirectToTermsOfUse"
          onClick={() => window.open(LINKS.termsOfUse, "_blank")}
        >
          {translate("termsOfUse")}
        </TypographyButton>
        <TypographyButton
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          data-cy="redirectToPrivacyPolicy"
          onClick={() => window.open("https://shipeezi.com/privacy-policy/", "_blank")}
        >
          {translate("privacyPolicy")}
        </TypographyButton>
      </StackFooter>
    </div>
  );
};

export default SetPassword;
